import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Class representing the tableBalanceAdjustmentsView.
 * Extends the JetView class to create a specific view for balance adjustments.
 */
export default class tableBalanceAdjustmentsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var vthis = this; // Reference to the current instance
        const canEdit = devConfig.getPermAction('updateCountryStatus', 'Edit');
        let header = [
            {
                id: 'rating',
                header: '',
                width: 50,
                height: 25,
                template: function (obj) {
                    // Template function to display edit icon based on permissions
                     return "<span class='webix_icon wxi-close edit'></span>"; 
                },
            },
            {
                id: 'Id',
                header: _('ID'), // Localized header
                width: 50,
                sort: 'int', // Sorting type
                fillspace: 1,
            },
            {
                id: 'Iso',
                header: _('Iso'), // Localized header
                width: 50,
                sort: 'int',
                fillspace: 1,
            },
            {
                id: 'NameCountry',
                header: _('Nombre'), // Localized header
                width: 100,
                sort: 'int',
                fillspace: 1,
            },
            {
                id: 'Currency',
                header: _('Moneda'), // Localized header
                width: 100,
                sort: 'int',
                fillspace: 1,
            },
            {
                id: 'State',
                header: _('Estado'), // Localized header
                width: 100,
                options: [
                    { id: 'A', value: _('Activo') }, // Active state
                    { id: 'I', value: _('Inactivo') }, // Inactive state
                ],
            },
            {
                id: 'Language',
                header: _('Lenguage'), // Localized header
                width: 100,
                sort: 'int',
                fillspace: 1,
            },
            {
                id: 'Utc',
                header: _('UTC'), // Localized header
                width: 100,
                sort: 'int',
                fillspace: 1,
            },
            {
                id: 'CellPrefix',
                header: _('Prefijo celular'), // Localized header
                width: 100,
                sort: 'int',
                fillspace: 1,
            },
            {
                id: 'CodePath',
                header: _('Código PATH'), // Localized header
                width: 100,
                sort: 'int',
                fillspace: 1,
            },
        ];
        if (!canEdit) {
            header= header.filter((item) =>item.id !== "rating")
        }
        return {
            rows: [
                {
                    cols: [
                        {
                            type: 'wide',
                            view: 'datatable',
                            id: 'datatable', // Unique identifier for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: header,
                            on: {
                                /**
                                 * Event triggered before loading data.
                                 * Displays a loading overlay.
                                 */
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                /**
                                 * Event triggered after loading data.
                                 * Hides the loading overlay.
                                 */
                                onAfterLoad: function () {
                                    this.hideOverlay();
                                },
                            },
                            /**
                             * Event triggered when the datatable is ready.
                             * Displays a 'no data' overlay if there are no records.
                             */
                            ready: function () {
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox);
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            onClick: {
                                /**
                                 * Event triggered when the edit icon is clicked.
                                 * Opens the edit form for the selected item.
                                 * @param {Event} euv - The event object.
                                 * @param {String} id - The ID of the clicked item.
                                 */
                                edit: function (e, id) {
                                    // In datatable clicks, `id` is usually an object: { row, column }
                                    var rowId = id && id.row ? id.row : id;
                                    var item = this.getItem(rowId); // Get the clicked item (row data)
                                    vthis.app.callEvent('openEdit', [item]); // Trigger the openEdit event
                                    return false;
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable instance
        var url = devConfig.geturlApi() + 'Setting/GetCountriesAll'; // API URL for fetching countries
        var filter = ''; // Filter string for API requests

        /**
         * Event listener for the 'report:filter' event.
         * Updates the grid data based on the provided filter data.
         * @param {Object} filterData - The filter data object.
         */
        this.on(this.app, 'report:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] == 'DateM') {
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom2=' + date[0];
                            string1 = string1 + '&dateTo2=' + date[1];
                        } else {
                            if (object[i][0] != 'Date') {
                                string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                            } else {
                                if (object[i][0] == 'Date') {
                                    var date = object[i][1].replace(' 00:00:00', ''); // Remove time from date
                                    string1 = string1 + '&dateFrom=' + date;
                                    string1 = string1 + '&dateTo=' + date;
                                }
                                if (object[i][0] == 'DateM2') {
                                    var date = object[i][1].replace(' 00:00:00', ''); // Remove time from date
                                    string1 = string1 + '&dateFrom2=' + date;
                                    string1 = string1 + '&dateTo2=' + date;
                                }
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object from start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append dateFrom to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object from end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append dateTo to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing grid data
            filter = string1; // Update filter string
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            $$('filterPopup').hide(); // Hide filter popup
        });

        /**
         * Event listener for the 'openEdit' event.
         * Opens the edit form for the selected item.
         * @param {Object} item - The item to edit.
         */
        this.on(this.app, 'openEdit', (item) => {
            // Avoid duplicated IDs if the user opens the editor multiple times
            const prev = $$('editMenu');
            if (prev) prev.destructor();

            const win = webix.ui({
                view: 'window',
                id: 'editMenu',
                fullscreen: screen.width < 500 ? true : false,
                width: 500,
                head: {
                    view: 'toolbar',
                    cols: [
                        { view: 'label', label: _('Editar'), align: 'center' },
                        {
                            view: 'icon',
                            icon: 'wxi-close',
                            click: function () {
                                this.getTopParentView().hide();
                            },
                        },
                    ],
                },
                position: 'center',
                modal: true,
                body: {
                    view: 'form',
                    id: 'editform',
                    elements: [
                        {
                            cols: [
                                {
                                    margin: 10,
                                    rows: [
                                        {
                                            view: 'text',
                                            labelPosition: 'top',
                                            label: _('ID'),
                                            name: 'Id',
                                            disabled: true,
                                        },
                                        {
                                            view: 'text',
                                            labelPosition: 'top',
                                            label: _('Iso'),
                                            name: 'Iso',
                                            disabled: true,
                                        },
                                        {
                                            view: 'text',
                                            labelPosition: 'top',
                                            label: _('Nombre'),
                                            name: 'NameCountry',
                                            disabled: true,
                                        },
                                        {
                                            view: 'text',
                                            labelPosition: 'top',
                                            label: _('Moneda'),
                                            name: 'Currency',
                                            disabled: true,
                                        },
                                        {
                                            view: 'combo',
                                            labelPosition: 'top',
                                            label: _('Estado'),
                                            name: 'State', // API expects lowercase "state"
                                            options: [
                                                { id: 'A', value: _('Activo') },
                                                { id: 'I', value: _('Inactivo') },
                                            ],
                                            required: true,
                                        },
                                    ],
                                },
                                {
                                    margin: 10,
                                    rows: [
                                        {
                                            view: 'text',
                                            labelPosition: 'top',
                                            label: _('Lenguage'),
                                            name: 'Language',
                                            disabled: true,
                                        },
                                        {
                                            view: 'text',
                                            labelPosition: 'top',
                                            label: _('UTC'),
                                            name: 'Utc',
                                            disabled: true,
                                        },
                                        {
                                            view: 'text',
                                            labelPosition: 'top',
                                            label: _('Prefijo celular'),
                                            name: 'CellPrefix',
                                            disabled: true,
                                        },
                                        {
                                            view: 'text',
                                            labelPosition: 'top',
                                            label: _('Código PATH'),
                                            name: 'CodePath',
                                            disabled: true,
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            cols: [
                                {
                                    view: 'button',
                                    value: _('Cancelar'),
                                    click: function () {
                                        this.getTopParentView().hide();
                                    },
                                },
                                {
                                    view: 'button',
                                    type: 'form',
                                    value: _('Guardar'),
                                    click: function () {
                                        const form = $$('editform');
                                        if (!form.validate()) return;

                                        const values = form.getValues();
                                        const payload = {
                                            Id: values.Id,
                                            State: values.State, // "A" or "I"
                                        };
                                        webix
                                            .ajax()
                                            .headers({ 'Content-type': 'application/json' })
                                            .post(devConfig.geturlApi() + 'Setting/UpdateCountries', payload, {
                                                error: function () {
                                                    webix.message('Error! ');
                                                },
                                                success: function (text) {
                                                    let resp;
                                                    try {
                                                        resp = JSON.parse(text);
                                                    } catch (e) {
                                                        webix.message('Respuesta inválida del servidor');
                                                        return;
                                                    }

                                                    if (resp.HasError) {
                                                        webix.message('Error: ' + resp.AlertMessage);
                                                    } else {
                                                        webix.message('País editado satisfactoriamente');
                                                        grid.load(
                                                            url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                        );
                                                    }
                                                },
                                            });
                                        this.getTopParentView().hide();
                                    },
                                },
                            ],
                        },
                    ],
                },
            });

            win.show();
            //Map datatable field "State" -> API/form field "state"
            $$('editform').setValues({ ...(item || {}), state: item && item.State }, true);
            $$('editform').clearValidation();
        });
    }
}

// FILE DOCUMENTED
